module.exports = __webpack_public_path__ + "img/cwell7.4653591b.jpg";